import axios from "axios";
import React, { useState, useEffect } from "react"
import News from "./News.jsx";
import loader from './loader.gif'

function Container() {
    
    const [loading, setloading] = useState(true);
    const [data, setdata] = useState(null);
    const [pagesize,setpagesize]=useState(9)
    const [totalarticles,settotalarticles]=useState(null)
    const [page,setpage]=useState(1)
    const [search, setsearch] = useState('');
    // const [searchcat, setsearchcat] = useState('');
    const [cat, setcat] = useState('technology');
    
    const url = `https://newsapi.org/v2/${search===''?'top-headlines':'everything'}?&${search===''?`country=in`:null}&${search===''?`category=${cat}`:null}&q=${search}&language=en&apiKey=${process.env.REACT_APP_API_KEY}&page=${page}&pagesize=${pagesize}`;
      
    const getdata = async ()=> {
    try{
        const fetched_data = await axios.get(url);   
        if (fetched_data.status === 200) {
          setloading(false)
        settotalarticles(fetched_data.data.totalResults)
        setdata(fetched_data.data.articles);

    } 
    }
    catch(e){
    console.log(e.message);
    }
    }

    useEffect(()=>{
      getdata();  
    },[search, cat,page])                                                                                                                             


    const handleNextClick =() =>{
    if(page> Math.ceil({totalarticles}/{pagesize})){
  console.log('last page')
  }
      else{
        setpage(page+1)}
      }
      const handlePrevClick= ()=>{
        if(page<=1){
        }
        else{
      setpage(page-1) }
      
      }
     
     
   

return (
<div>
  

<nav className="nav-bar">
<h1 className="nav-header">News App</h1>
  <ul className=" nav-li">
    <li className="nav-items" onClick={() => { setcat('business') }}>Bussiness</li>
    <li className="nav-items"onClick={() => { setcat('entertainment')} }>Entertainment</li>
    <li className="nav-items"onClick={() => { setcat('general') }}>General</li>
    <li className="nav-items"onClick={() => { setcat('health') }}>Health</li>
    <li className="nav-items"onClick={() => { setcat('science') }}>Science</li>
    <li className="nav-items"onClick={() => { setcat('sport') }}>Sports</li>
    <li className="nav-items"onClick={() => { setcat('technology') }}>Technology</li>
  </ul>
<div className="inp-form-nav">
  <input className="inp" placeholder="search here for news" type='text' value={search} onChange={(e) => { setsearch(e.target.value) }} />
  </div>
</nav>

    <div className='head'>
<h1 className="main-head"> ---------TOP HEADLINES---------- </h1>
</div>

       <section className="news-container">
        { !loading ?
        

        data?.map((elem, index) => {
              return <News key = {index} data={elem}/>;
            })
            :
            <div className="loader">
            <img src={loader} className='loader-i' />

            </div>
          }
          </section>
        <div className="pages">
          <button   className="btn" id="pr"  onClick={handlePrevClick}>Previous</button>
          <button      className="btn" id="nx" onClick={handleNextClick}>Next</button>
        </div>
 </div>
    )
}

export default Container